<template>
  <div>
    <div class="d-flex align-center mt-1 mb-4">
      <div class="d-flex"><p class="ma-0 mx-2">지연시간</p></div>
      <div class="flex-grow-1">
        <DelaySlider :value="cmd" @change="onChangeDelay"></DelaySlider>
      </div>
    </div>
    <div>
      <v-chip
        style="margin: 2px"
        v-for="(action, i) in allActions"
        :key="i"
        :color="_isActive(action.actionId) ? 'primary' : 'grey'"
        @click="onClickAction(action.actionId)"
        @click:close="onClickRemove"
        :close="_isActive(action.actionId)"
        small
        >{{ action.label || action.name }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import { isLocal } from "@/utils/env-utils";

import inputActionsMeta from "../../../domain/BroadCastResourceManager/inputActionsMeta.json";
import CMD_TYPE from "@/constants/CMD_TYPE";
import ResourceApi from "@/api/ResourceApi";

// [SSOT는 DB animation_label] 아래 LABEL_MAP + inputActionsMeta.json은 DB 미응답 시 fallback.
const LABEL_MAP = {
  "Action Idle To Fight Idle": "덤벼",
  Angry: "칫!",
  "Angry Gesture": "실망",
  "Arm Gesture": "저거 갖고 싶어",
  "Breakdance Freezes": "브레이크댄스",
  "Brutal To Happy Walking": "성큼성큼",
  "Catwalk Walk Turn 180 Tight": "산책중",
  Charge: "돌격 앞으로!!",
  Cheering: "신난다 >.<",
  Clapping: "박수",
  "Dancing Maraschino Step": "흔들흔들 댄스",
  "Death Crouching Headshot Front": "꽤꼬닥 앞으로",
  "Death From Back Headshot": "꽤꼬닥 철푸덕",
  "Death From Front Headshot": "꽤꼬닥 뒤로",
  "Death From Right": "꽤꼬닥 옆으로",
  "Death From The Back": "으윽",
  Defeated: "아 쫌!!",
  "Dismissing Gesture": "하찮은 손짓",
  "Dismissing Gesture (1)": "아유 손짓",
  Dying: "빵 으악!",
  Excited: "아싸 신난다",
  Falling: "폴링",
  Floating: "사뿐사뿐",
  "Getting Up": "재빨리 일어나기",
  "Getting Up (1)": "느리게 일어나기",
  Happy: "헤헿",
  "Happy Idle": "행복 흔들",
  "Happy Walk": "앞으로 걷기",
  "Hard Head Nod": "조는중",
  "Hip Hop Dancing": "힙합댄스",
  "Hip Hop Dancing (1)": "웨이브 댄스",
  "Hurricane Kick": "허리케인 킥",

  "Jazz Dancing": "재즈 댄스",
  "Jog Backward Diagonal": "뒤로 슈슈슉",
  "Jog Forward": "앞으로 걷기",
  "Jog Forward Diagonal": "호다닥",
  "Jog In Circle": "운동중",
  Jogging: "앞으로 슈슈슉",
  "Jogging Stumble": "앞으로 걷다가 콰당",
  Jump: "펫 점프",
  "Jump (1)": "멀리뛰기",
  Jumping: "족발당수",
  "Jumping Down": "펫착지",
  "Kip Up": "무림고수 일어나기",
  "Kneeling Pointing": "저기봐봐",
  "Laying Hand Gesture": "새근새근",
  "Laying Shrugging": "누워서 잠자기",
  //
  "legacy-agree": "동의함",
  "legacy-angry": "화남",
  "legacy-deahat": "데햇",
  "legacy-die": "죽는다",
  "legacy-happy": "행복해",
  "legacy-hi": "정중한 인사",
  "legacy-sleep": "조는중",
  // "legacy-thankyou": "감사합니다",
  "legacy-embarrassment": "화들짝",
  //
  // "Lengthy Head Nod": "",
  // "Male Sitting Pose": "",
  "Martelo 2": "옆차기",
  "Pain Gesture": "아악 허리",
  "Pointing Forward": "너가 그랬자노",
  "Pointing Gesture": "예스",
  Praying: "제발요",
  "Praying (1)": "무릎 제발요",
  "Quick Formal Bow": "대충인사",
  "Quick Informal Bow": "가벼운인사",
  "Robot Hip Hop Dance": "힙합댄싱",
  "Rumba Dancing": "럼바댄싱",
  "Running Jump": "앞으로 뛰기",
  "Running To Turn": "돌진 후 뒤돌기",
  "Sad Idle": "쳇!!",
  "Sarcastic Head Nod": "한숨",
  "Shake Gesture": "빨리요",
  "Short Left Side Step": "취칫 덤벼",
  "Shoved Reaction With Spin": "앞으로 가서 점프뒤돌기",
  "Silly Dancing": "맷돌춤",
  "Sitting Laughing": "앉아서 웃기",
  "Slow Jog": "꽃게걸음",
  "Stand Up": "대자로 자다가 일어나기",
  "Standing Greeting": "시크하게 인사하기",
  "Standing Taunt Battlecry": "쿠오오",
  "Standing Up": "앉아있따가 일어나기",
  "Standing W_Briefcase Idle": "시계보기",
  "Strike Foward Jog": "궁디를 빵",
  "Stroke Hand Gesture": "깨우지 마쇼",
  "Strong Gesture": "나는 강하다",
  Surprised: "깜딱이야",
  Swimming: "헤엄치기",
  "Swing Dancing": "스윙 댄스",
  "Taunt Gesture": "아 윌 킬유",
  Waving: "귀여운 안녕",
  "Waving Gesture": "귀기울이며 안녕",
  Yelling: "말했재!!",
  "Yelling While Standing": "소리치는중",
  "Zombie Punching": "어퍼컷",
  "Zombie Stand Up": "일어나는중",
  "Zombie Stumbling": "에구구구 콰당",

  //
  "{{loop}}Happy": "",
  "{{loop}}Happy Idle": "",
  "{{loop}}Head Nod Yes": "",
  "{{loop}}Idle-100": "",
  "{{loop}}Idle-40": "",
  "{{loop}}Idle-50": "",
  "{{loop}}Idle-60": "",
  "{{loop}}Standing W_Briefcase Idle": "",

  // "Zombie Idle": "",
  // "Thoughtful Head Nod": "", // idle
  // "Head Nod Yes": "",
  // "Breathing Idle": "",
  // "Idle-100": "",
  // "Idle-40": "",
  // "Idle-50": "",
  // "Idle-60": "",
};

// DB animation_label 캐시: { [clipName]: { label, modifiedAt } }. 1회 로드, 실패 시 fallback 유지.
let _animMeta = null;
let _animMetaPromise = null;
function ensureAnimMeta() {
  if (_animMetaPromise) return _animMetaPromise;
  _animMetaPromise = (async () => {
    try {
      const rows = await ResourceApi.fetchAnimationLabels();
      const map = {};
      rows.forEach((r) => {
        map[r.clip_name] = { label: r.label_ko, modifiedAt: r.modified_at };
      });
      _animMeta = map;
    } catch (e) {
      console.warn("[ModelActionCmd] animation_label 로드 실패 — fallback 사용", e);
    }
  })();
  return _animMetaPromise;
}
const lookupLabel = (name) => (_animMeta && _animMeta[name] ? _animMeta[name].label : LABEL_MAP[name]);
const lookupModifiedAt = (name) =>
  _animMeta && _animMeta[name] ? _animMeta[name].modifiedAt : inputActionsMeta[name] ? inputActionsMeta[name].modifiedAt : null;

export default {
  model: {
    prop: "cmd",
    event: "change",
  },
  props: {
    cmd: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedActionId: null,
      allActions: [],
    };
  },
  async created() {
    await ensureAnimMeta();
    if (this._lastClips) this.update(this._lastClips); // 라벨 로드 후 재매핑
  },
  methods: {
    update(animationClips = [] /* threejs animationClips */) {
      if (isLocal() && animationClips.length === 0) console.warn("No animationClips found");
      this._lastClips = animationClips;

      this.allActions = animationClips //
        .filter((a) => !a.name.includes("Armature"))
        .filter((a) => !a.name.includes("mixamo"))
        .map((a) => a.name)
        .map((name) => ({
          name,
          label: lookupLabel(name),
          modifiedAt: lookupModifiedAt(name),
          actionId: `animation--${name.toLowerCase()}`,
        }))
        // .sort((a, b) => (new Date(a.modifiedAt) < new Date(b.modifiedAt) ? 1 : -1));
        .sort((a, b) => (a.name < b.name ? -1 : 1));
      // .filter((a) => a.label && a.label !== "");
    },

    onClickAction(actionId) {
      const cmd = this.makeSeedCmd();
      cmd.argSchema1.actionId = actionId;
      this.$emit("change", cmd);
    },
    onClickRemove() {
      this.$emit("change", null);
    },
    onChangeDelay(delay_ms) {
      const cmd = this.makeSeedCmd();
      cmd.delay = delay_ms;
      this.$emit("change", cmd);
    },
    makeSeedCmd() {
      if (!this.cmd) {
        return {
          _type: CMD_TYPE.MODEL,
          delay: null,
          targetRef: "model",
          argSchema1: { actionId: this.selectedActionId },
        };
      }

      return JSON.parse(JSON.stringify(this.cmd));
    },
    _isActive(actionId) {
      if (!this.cmd) return false;

      return this.cmd.argSchema1.actionId === actionId ? true : false;
    },
  },
};
</script>

<style></style>
